<template>
  <el-header style="height: 70px">
    <div class="headerMain flex">
      <div class="flex" style="align-items: center">
        <img :src="generalSetting.logo" class="logo" />
        <el-menu
                class="dis-menu"
                :default-active="activeIndex"
                mode="horizontal"
                text-color="#333"
                active-text-color="#266ef6"

        >
          <template v-for="item in menuList">
            <template v-if="item.linkUrl == ''">
              <el-menu-item
                      index=""
                      v-if="item.enabled == 1"
                      :key="item.id"
                      @click="hrefTo(tikuDomain + '/login')"
              >{{ item.title }}</el-menu-item
              >
            </template>
            <template v-else>
              <el-menu-item
                      :index="item.linkUrl"
                      v-if="item.enabled == 1"
                      :key="item.id"
              >{{ item.title }}</el-menu-item
              >
            </template>
          </template>
        </el-menu>
      </div>

      <div>
        <el-input placeholder="请输入内容" v-model="searchCon" class="input-with-select">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>

      <div v-if="loading == true">
        <div v-if="isLogin == true">

          <el-dropdown>
            <span class="el-dropdown-link">
              {{ user.name || user.mobile }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="loginOut">
                <span class="icon iconfont icon-tuichu"></span>退出登录
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div v-else class="flex">
          <div class="loginBtn" @click="hrefTo(tikuDomain + '/login')">
            登陆
          </div>
          <div
                  class="loginBtn register"
                  @click="hrefTo(tikuDomain + '/login?regist=1')"
          >
            注册
          </div>
        </div>
      </div>
    </div>
  </el-header>
</template>

<script>
    import axios from "@/api/config";

    export default {
        head() {
            return {
                title: this.companyInfo.title,
                link: [
                    { rel: "icon", type: "image/x-icon", href: this.companyInfo.icoPic },
                ],
            };
        },
        data() {
            return {
                searchCon:'',
                activeIndex: "/",
                companyInfo: {},
                isLogin: false,
                user: {},
                tikuDomain: "",
                loading: false,
                menuList: [],
                generalSetting: {},
            };
        },
        methods: {
            loginOut() {
                this.$confirm("确定退出登录?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                        .then(() => {
                            localStorage.setItem("isLogin", false);
                            localStorage.removeItem("user");
                            this.init();
                        })
                        .catch(() => {});
            },
            hrefTo(url) {
                window.location.href = url;
            },
            init() {
                this.loading = false;
                this.isLogin = JSON.parse(localStorage.getItem("isLogin"));
                this.user = JSON.parse(localStorage.getItem("user"));
                this.loading = true;
            },
            async getAgentId() {
                await axios.get(`${process.env.BASE_URL}/generalSetting/getGeneralSetting`).then((res) => {
                    if (res.code == 200) {
                        this.generalSetting = res.data;
                        this.tikuDomain = "//" + this.generalSetting.domain + "/student";
                        localStorage.setItem("tikuDomain", this.tikuDomain);
                        localStorage.setItem("agentId", this.generalSetting.agentId);
                    }
                });
            },
        },
        async beforeMount() {
            if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
                // alert("移动端");
                let agentId = localStorage.getItem("agentId");
                if (!agentId) {
                    await this.getAgentId();
                    agentId = this.generalSetting.agentId;
                }
                if (window.location.href.indexOf('test') > -1) {
                    // 测试环境  ${agentId}. 暂时不支持 agentId
                    window.location.replace(`http://test.h5.68wx.com`);
                } else window.location.replace(`http://${agentId}.h5.68wx.com`); // 线上环境
            }
        },
        async mounted() {
            await this.init();
            this.activeIndex = this.$route.path;
            await this.getAgentId();
            await axios.get(`${process.env.BASE_URL}/schoolPageMenu/getApiSchoolPageMenuListByUrl`, {
                params: { url: "/" },
            }).then((res) => {
                this.menuList = res.data;
            });
        },
        watch: {
            $route: {
                handler: function (val, oldVal) {
                    this.activeIndex = this.$route.path;
                },
                // 深度观察监听
                deep: true,
            },
        },
    };
</script>

<style lang="less" scoped>
  @media (max-width: 979px) {
    .dis-menu {
      display: none;
    }
  }

  .el-header {
    width: 100%;
    background-color: #fff;
    position: relative;
    // padding: 0 160px;
  }
  .el-header .logo {
    height: 40px;
    min-width: 160px;
  }
  .headerMain {
    // width: 1200px;
    // min-width: 950px;
    margin: 0 auto;
    align-items: center;
    justify-content: space-between;
  }
  .el-menu {
    margin: 0 50px;
  }
  // a:-webkit-any-link {
  //     text-decoration: inherit!important;
  // }
  .loginBtn {
    padding: 3px 18px;
    cursor: pointer;
    border-radius: 20px;
    background-color: #266ef6;
    color: #fff;
    font-size: 15px;
  }
  .register {
    border: 1px solid #266ef6;
    color: #266ef6;
    background-color: #fff;
    margin-left: 10px;
  }
</style>




// WEBPACK FOOTER //
// src/components/onlineSchool/diyTemplate/Header.vue